// External
import React from "react";
import _ from "lodash";
import { compose, graphql } from "lib/apolloClient";

// Design system
import { EmptyState } from "@toddle-edu/ds-web";
import { NoDataIllustration } from "@toddle-edu/ds-theme";
import withLoader from "UIComponents/GqlWithLoader";
import FeedListv2 from "AppComponents/FeedListv2";

// Relative
import { getRatingLogsQuery } from "./modules/RatingLogsQueries";
import {
  getRatingLogsColumnList,
  getRatingLogsFeedData,
  getRatingLogsQueryInput,
} from "./modules/RatingLogsUtils";
import DownloadTableData from "../DownloadTableData/DownloadTableData";

// Styles
import classes from "./RatingLogsModal.scss";

const styles = {
  emptyStateSubtitleStyle: {
    maxWidth: "448px",
  },
};

const RatingLogsModal = props => {
  const { ratingLogsData, data } = props;

  const columnList = getRatingLogsColumnList({
    curriculumProgramType: data.curriculumProgramType,
  });
  const feedData = getRatingLogsFeedData({
    data: ratingLogsData,
    curriculumProgramType: data.curriculumProgramType,
  });

  if (_.isEmpty(feedData)) {
    return (
      <div className={classes.emptyStateContainer}>
        <EmptyState
          title="No rating logs found"
          subtitle="There are no rating logs recorded for this progress report set yet"
          subtitleStyle={styles.emptyStateSubtitleStyle}
          illustration={NoDataIllustration}
        />
      </div>
    );
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <h2 className="heading-2">Ratings Logs</h2>
        <DownloadTableData
          feedData={feedData}
          columnList={columnList}
          fileName="rating_logs"
        />
      </div>
      <div className={classes.tableContainer}>
        <FeedListv2
          columnList={columnList}
          feedData={feedData}
          enableStickyHeader={true}
          headerTheme="subtle"
          showBorder={true}
        />
      </div>
    </div>
  );
};

export default compose(
  graphql(getRatingLogsQuery, {
    name: "getRatingLogsQuery",
    options: ({ data }) => {
      return {
        fetchPolicy: "cache-and-network",
        variables: {
          input: getRatingLogsQueryInput({
            data,
          }),
        },
      };
    },
    props: ({ getRatingLogsQuery }) => {
      const queryData = _.get(getRatingLogsQuery, "documentation", {});
      const ratingLogsData = _.get(
        queryData,
        "internalToolsData.progressReport.ratingLogs",
        []
      );

      return {
        ratingLogsData,
        isData: !_.isEmpty(queryData),
        isLoading:
          _.get(getRatingLogsQuery, "networkStatus") == 1 ||
          _.get(getRatingLogsQuery, "networkStatus") == 2,
      };
    },
  }),
  withLoader
)(RatingLogsModal);
